import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import ThreeDayPTTrialStructure from "../../components/pt/three-day-trial/ThreeDayPTTrialStructure";

const ThreeDayPTTrial = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return <ThreeDayPTTrialStructure userInfoData={userInfoData} />;
};

export default ThreeDayPTTrial;